module.exports = __webpack_public_path__ + "img/red-bottle.1be83c65.png";